export const extractErrorMessage = (error, defaultMessage) => {
  const errorsArray = error?.response?.data?.errors || [defaultMessage]

  const errorMessage = errorsArray.reduce((acc, curr) => {
    const init = acc ? `${acc}\n` : ''

    if (typeof curr === 'string') {
      return `${init}${curr}`
    }

    if (typeof curr === 'object') {
      const errors = Object.entries(curr)
        .map(([field, message]) => `${field}: ${message}`)
        .join('\n')
      return `${init}${errors}`
    }

    return acc
  }, '')

  return errorMessage
}
